import { all, takeEvery, put, fork, call } from "redux-saga/effects";

import { aiCheckHistoryService } from "@iso/services";
import actions from "@iso/redux/aiCheckHistory/actions";

const mapCheckJobRow = (item) => ({
  executionId: item.aiCheckRequestId,
  executedAt: item.createdAt,
  facilityCredentialId: item.facilityCredentialId,
  requestContent: item.requestContent,
  executionStatus: item.status,
  requestType: item.type,
});

function* getList() {
  yield takeEvery(actions.GET_AI_CHECK_LIST_REQUEST, function* ({ payload }) {
    const { facilityCredentialId, executionStatus, requestType, size, page, resolve, reject } =
      payload;
    const offset = (page - 1) * size;

    try {
      const response = yield call(aiCheckHistoryService.getList, {
        type: requestType,
        facilityCredentialId,
        status: executionStatus,
        size,
        offset,
      });
      yield put({
        type: actions.GET_AI_CHECK_LIST_SUCCESS,
        checkJobs: (response?.rows || []).map(mapCheckJobRow),
        total: response?.total || 0,
      });
      if (resolve) {
        yield resolve(response);
      }
    } catch (e) {
      yield put({
        type: actions.GET_AI_CHECK_LIST_ERROR,
        error: e.message,
      });
      if (reject) {
        yield reject(e);
      }
    }
  });
}

function* create() {
  yield takeEvery(actions.CREATE_AI_CHECK_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(aiCheckHistoryService.create, { ...data });
      yield put({
        type: actions.CREATE_AI_CHECK_SUCCESS,
      });
      if (resolve) {
        yield resolve(response);
      }
    } catch (e) {
      yield put({
        type: actions.CREATE_AI_CHECK_ERROR,
        error: e.message,
      });
      if (reject) {
        yield reject(e);
      }
    }
  });
}

function* normalize() {
  yield takeEvery(actions.NORMALIZE_AI_CHECK_REQUEST, function* ({ payload }) {
    const { data, resolve, reject } = payload;
    try {
      const response = yield call(aiCheckHistoryService.normalize, { ...data });
      yield put({
        type: actions.NORMALIZE_AI_CHECK_SUCCESS,
      });
      if (resolve) {
        yield resolve(response);
      }
    } catch (e) {
      yield put({
        type: actions.NORMALIZE_AI_CHECK_ERROR,
        error: e.message,
      });
      if (reject) {
        yield reject(e);
      }
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getList), fork(create), fork(normalize)]);
}
